import { Box, MenuItem, FormControl, Select } from '@mui/material';
import { SelectChangeEvent } from '@mui/material/Select';
import { CampaignFormModel } from '../../../models/campaign';
import { useController, useFormContext } from 'react-hook-form';

interface ImagePlayProps {
  onDurationChange: (newDuration: number) => Promise<void>;
}

export default function ImagePlaySection({ onDurationChange }: ImagePlayProps) {
  const { control, watch } = useFormContext<CampaignFormModel>();
  const { field: durationField } = useController({
    name: 'file.duration',
    control,
  });

  const asset = watch('file.asset');

  const currentCampaignId: number | undefined =
    Number(window.location.pathname.split('/')[2]) || undefined;

  const isDisabled = !asset && typeof currentCampaignId === 'number';

  const handleChange = (event: SelectChangeEvent) => {
    durationField.onChange(event.target.value);
    onDurationChange(Number(event.target.value));
  };

  const durationList = watch('durationList') || [];

  const formatDuration = (seconds: number): string => {
    return seconds.toString().padStart(2, '0');
  };

  return (
    <Box display="flex" alignItems="center" sx={{ height: '36px', gap: '8px' }}>
      <FormControl size="small">
        <Select
          id="image-duration-select"
          size="small"
          displayEmpty
          value={
            durationList.length > 0 && durationField.value
              ? durationField.value.toString()
              : ''
          }
          onChange={handleChange}
          disabled={isDisabled}
          inputProps={{ 'aria-label': 'Without label' }}
          MenuProps={{
            sx: {
              '& .MuiMenu-list': {
                backgroundColor: 'secondary.contrastText',
              },
            },
          }}
          sx={{
            '& .MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
          }}
        >
          {durationList.map((duration) => (
            <MenuItem key={duration} value={duration}>
              00:{formatDuration(duration ?? 0)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}
